const SchCalendar = () => import('@/components/calendar/Calendar')
export default function buildMenu (allowed) {
  var routes = []
  if (allowed == null 
    || allowed.includes('Tasks')
    || allowed.includes('Calendar'))  {
    routes =  [
      {
        name: 'SchCalendar', 
        path: '/SchCalendar', 
        component: SchCalendar
      }
  ] 
} 
  
  return routes
}
